import {
  formatTimesheetDateRange,
  type PayPeriod,
  type PayPeriodSelection,
} from '@/modules/timesheets/utils/timesheetGroups.utils';

interface PayPeriodSwitcherProps {
  periods: Record<PayPeriodSelection, PayPeriod>;
  selected: PayPeriodSelection;
  onChange: (selected: PayPeriodSelection) => void;
}

const PERIOD_ORDER: PayPeriodSelection[] = ['previous', 'current'];

const buttonClassName =
  'flex h-9 cursor-pointer items-center justify-center rounded-lg border px-3 text-sm font-medium whitespace-nowrap';

/** Flicks between the previous pay period and the current one. */
const PayPeriodSwitcher = ({
  periods,
  selected,
  onChange,
}: PayPeriodSwitcherProps) => {
  return (
    <div className="flex items-center gap-2">
      {PERIOD_ORDER.map((periodKey) => {
        const period = periods[periodKey];
        const isSelected = selected === periodKey;
        const label = formatTimesheetDateRange(
          period.startDateISO,
          period.endDateISO,
        );

        return (
          <button
            key={periodKey}
            type="button"
            aria-pressed={isSelected}
            className={`${buttonClassName} ${
              isSelected
                ? 'border-gray-900 bg-white text-gray-900'
                : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
            }`}
            onClick={() => onChange(periodKey)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default PayPeriodSwitcher;
